import React from "react";

// Class component because React Error Boundaries require lifecycle hooks that
// are not available to function components.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Keep a copy in the console so it is still visible while we ship
    // structured logging. Swap for a telemetry hook later if needed.
    // eslint-disable-next-line no-console
    console.error("Caught by ErrorBoundary:", error, info);
  }

  // Lazy-route chunks are content-hashed; after a redeploy an open tab may
  // request a chunk that no longer exists. React.lazy caches the rejected
  // import, so re-rendering can never recover — only a full reload can.
  isChunkError = () => {
    const err = this.state.error;
    return !!err && (
      err.name === "ChunkLoadError" ||
      /Loading (CSS )?chunk [\d]+ failed/i.test(err.message || "") ||
      /Unexpected token '<'/.test(err.message || "")
    );
  };

  reset = () => {
    if (this.isChunkError()) {
      window.location.reload();
      return;
    }
    this.setState({ error: null });
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main
        style={{
          maxWidth: 600,
          margin: "60px auto",
          padding: "20px 16px",
          color: "#fff",
          textAlign: "center",
          fontFamily: "'Space Grotesk', sans-serif",
          lineHeight: 1.6,
        }}
      >
        <h1 style={{ color: "#ff5577", fontSize: 22, marginBottom: 10 }}>Something went wrong</h1>
        <p style={{ color: "#c0ccff", marginBottom: 20 }}>
          {this.isChunkError()
            ? "The site was updated since this page loaded. Reload to get the latest version."
            : "An unexpected error happened on this page. You can try again, go home, or refresh."}
        </p>
        <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={this.reset}
            style={{
              background: "#3344aa",
              color: "#fff",
              border: "3px solid #1a2266",
              borderRadius: 6,
              padding: "8px 16px",
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "inherit",
              boxShadow: "2px 3px 0 #0a1040",
            }}
          >
            Try again
          </button>
          <a
            href="/"
            style={{
              background: "#ffd700",
              color: "#0d1654",
              border: "3px solid #ccaa00",
              borderRadius: 6,
              padding: "8px 16px",
              fontWeight: 700,
              textDecoration: "none",
              boxShadow: "2px 3px 0 #0a1040",
            }}
          >
            Home
          </a>
        </div>
      </main>
    );
  }
}
